<template>
<div class="container-fluid">
  <div class="row">
    <div class="col-6">
      <div class="input-group mt-2">
        <label class="input-group-text" for="inputGroupSelect01">ห้องตรวจทางคลินิก : </label>
        <select class="form-select" id="inputGroupSelect01" aria-label="Example select with button addon"
          @change="roomType_Changed()" style="background-color:yellow;"
          v-model="roomtypeID">
          <option disabled style="background-color:white;">เลือกห้องตรวจ..</option>
          <option value="0" style="background-color:white;">ทุกห้องตรวจทางคลินิก</option>
          <option v-for="item in roomtypeList" :key="item.id" style="background-color:white;"
              :value="item.id">
            {{item.room_name}}
          </option>
        </select>
        <!-- <button class="btn btn-primary" type="button" @click="btnCatMenuClicked()"><i class="fa fa-object-group"></i> Manage Groups</button> -->
      </div>
    </div>
  </div>

  <MTests1View :key="countRefresh"
    :roomtypeList="roomtypeList"
    :roomtypeID="roomtypeID"
    @onDataChangedEvent="refreshView"></MTests1View>
</div>
</template>

<script>
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
// import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import MTests1View from './MTests1View.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'Tests',
  components: {
    MTests1View
  },
  data () {
    return {
      countRefresh: 0,

      roomtypeList: [],
      roomtypeID: 0
    }
  },
  mounted () {
    this.getRoomTypeData()
  },
  methods: {
    roomType_Changed () {
      this.countRefresh++
    },
    refreshView () {
      this.countRefresh++
    },
    getRoomTypeData () {
    // axios.get('http://www.irissar.com/projects/parking/service/park_building/pb_like.php?key=%' + this.search_text + '%', {crossDomain: true})
      MyApiClient.get('getdata/roomtype_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.roomtypeList = resp.data.response
          // setTimeout(function () { $('#myTSTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}

</script>

<style>
.page-scroll {
  /* max-height: 800px; */
  /* height: 800px; */
  /* overflow: auto; */
  max-height: 1200px;
  height: 1000px;
  overflow-y: scroll;
}
.dropdown-item:hover{
  background-color: rgb(255, 238, 0);
  color: black;
  cursor: pointer;
}
</style>
